var rich_content_viewer_default = {
  "fontElementMap": "RQWso",
  "wrapper": "WsvrS",
  "pluginContainerMobile": "_7Qiy0",
  "viewer": "vY-p7",
  "android": "qIHzA",
  "rootedTraversedContent": "_6ZCSF",
  "atomic": "ZfaeY",
  "toolbar": "Ti-U7",
  "block": "_6-Qcw"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
